import React, { Fragment } from 'react';
import { isIOS } from 'react-device-detect';
import { isApp } from './index'; // imported functional flag

/**
 * @desc Check if device is `mobile` and platform is `iOS-app`.
 * @example
 * import { isIosApp } from 'core/modules/device-detect';
 */
export const isIosApp = () => {
	return isApp() && isIOS;
};

/**
 * @desc Render children if device is `mobile` and platform is `iOS-app`.
 * @example
 * import { ForIosApp } from 'core/modules/device-detect';
 */
export const ForIosApp = ( props ) => {
	if( isIosApp() ) {
		return (
			<Fragment>
				{ props.children }
			</Fragment>
		);
	} else {
		return null;
	}
};
